import { Badge, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ClientCustomerListItemType } from '@econtractor/types';
import type { NewObjectType } from 'modules/lead';
import type { NewSaleType } from 'modules/objects';
import ClientNameItem from '../../ClientsRows/ClientNameItem';
import ClientCustomerAction from '../../OffClientCustomers/ClientCustomerAction';

interface CustomersListTableRowProps {
    row: ClientCustomerListItemType;
    onEdit: (row: ClientCustomerListItemType) => void;
    onDelete: (row: ClientCustomerListItemType) => void;
    onCreateSale: (sale: NewSaleType) => void;
    onCreateObject: (object: NewObjectType) => void;
}

const CustomersListTableRow = ({
    row,
    onEdit,
    onDelete,
    onCreateSale,
    onCreateObject,
}: CustomersListTableRowProps) => {
    const { t } = useTranslation(['Objects']);

    const personType = row.customer?.personType;
    const personTypeLabel =
        personType === 'legal'
            ? t('customer.personTypes.legal')
            : personType === 'individual'
              ? t('customer.personTypes.individual')
              : personType || '-';

    return (
        <tr className="cursor-pointer" onClick={() => onEdit(row)}>
            <td className="subject-name text-break">
                <h6 className="mb-1 text-break">{row.fullName || '-'}</h6>
                <p className="text-muted f-12 mb-0 my-1">{row.edrpouOrIpn || '-'}</p>
            </td>
            <td className="name" onClick={(e) => e.stopPropagation()}>
                <Col>
                    <ClientNameItem
                        client={{
                            ID: row.clientId,
                            clientName: row.clientName,
                            clientPhone: row.clientPhone,
                        }}
                        onClick={() => onEdit(row)}
                    />
                </Col>
            </td>
            <td className="vat">
                {row.vatEnabled ? (
                    <Badge className="mx-1 badge text-bg-danger" style={{ fontSize: 8 }}>
                        {t('vat')}
                    </Badge>
                ) : null}
            </td>
            <td className="status">{personTypeLabel}</td>
            <td className="action" onClick={(e) => e.stopPropagation()}>
                <ClientCustomerAction
                    row={row}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onCreateSale={onCreateSale}
                    onCreateObject={onCreateObject}
                />
            </td>
        </tr>
    );
};

export default CustomersListTableRow;
